// extracted by mini-css-extract-plugin
module.exports = {"assistBotContainer":"AssistBot_assistBotContainer__PdBKE"};